import { useState } from "react";
import ProjectDetail from "./components/ProjectDetail";
import ProjectManager from "./components/ProjectManager";

enum EDITOR_MODE {
  MANAGE_PROJECTS,
  PROJECT_DETAIL,
}

export default function Editor({ onClickPlay }: { onClickPlay: () => void }) {
  const [activeEditorMode, setActiveEditorMode] = useState<EDITOR_MODE>(
    EDITOR_MODE.MANAGE_PROJECTS
  );
  const [activeProjectId, setActiveProjectId] = useState("");

  return activeEditorMode === EDITOR_MODE.MANAGE_PROJECTS ? (
    <ProjectManager
      onGoToProjectDetailClick={(projectId: string) => {
        setActiveProjectId(projectId);
        setActiveEditorMode(EDITOR_MODE.PROJECT_DETAIL);
      }}
      onClickPlay={() => {
        onClickPlay();
      }}
    />
  ) : (
    <ProjectDetail
      activeProjectId={activeProjectId}
      onGoToManagerClick={() => {
        setActiveEditorMode(EDITOR_MODE.MANAGE_PROJECTS);
      }}
      onClickPlay={() => {
        onClickPlay();
      }}
      projectId={activeProjectId}
    />
  );
}
